import { useTranslation } from "react-i18next";
import { CalendarClock, MapPin, Trash2, Users } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { RefBadge } from "../../components/neu/RefBadge";

const TONES = {
  active: "text-primary border-primary/40",
  done: "text-success border-success/40",
  cancelled: "text-destructive border-destructive/40",
};

export const DutyCard = ({ duty, names, onDelete, onStatus }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="animate-rise-in p-5" data-testid={`duty-card-${duty.id}`}>
        <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-lg font-bold">{duty.title}</p>
          <RefBadge value={duty.ref_no} className="mt-1" />
          <p className="truncate text-xs text-muted-foreground">{duty.address || "—"}</p>
        </div>
        <span className={`shrink-0 rounded-full border px-2.5 py-1 text-[10px] font-bold ${TONES[duty.status]}`}>
          {t(`duty.status.${duty.status}`)}
        </span>
      </div>

      <dl className="mt-4 grid gap-2 font-mono text-xs">
        <p className="flex items-center gap-2">
          <CalendarClock className="h-3.5 w-3.5 text-primary" />
          <span dir="ltr">
            {duty.date}
            {duty.end_date ? ` → ${duty.end_date}` : ""}
            {duty.start_time ? ` · ${duty.start_time}–${duty.end_time || ""}` : ""}
          </span>
        </p>
        <p className="flex items-center gap-2">
          <MapPin className="h-3.5 w-3.5 text-primary" />
          <span dir="ltr">
            {Number(duty.latitude).toFixed(5)}, {Number(duty.longitude).toFixed(5)} · {duty.radius_m} m
          </span>
        </p>
        <p className="flex items-start gap-2">
          <Users className="mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" />
          <span className="font-sans font-semibold">{names || "—"}</span>
        </p>
      </dl>

      {duty.notes ? <p className="mt-3 text-xs text-muted-foreground">{duty.notes}</p> : null}

      <div className="mt-5 flex gap-2 border-t border-border/50 pt-4">
        {duty.status === "active" ? (
          <NeuButton
            className="flex-1 px-4 py-2"
            data-testid={`duty-done-${duty.id}`}
            onClick={() => onStatus(duty, "done")}
          >
            {t("duty.markDone")}
          </NeuButton>
        ) : null}
        <NeuButton variant="danger" className="px-4 py-2" data-testid={`duty-delete-${duty.id}`} onClick={() => onDelete(duty)}>
          <Trash2 className="h-4 w-4" />
        </NeuButton>
      </div>
    </NeuCard>
  );
};
